// TabMenu.js
import React from "react";
import HeaderSection from "./HeaderSection";
import header1 from "../assets/header1.png";
import header9 from "../assets/header9.png";
import header10 from "../assets/header10.jpg";
import header5 from "../assets/header5.jpg";

const TabMenu = () => {
    const tabContentList = [
        {
            title: "Organisez tous vos clients facilement",
            subtitle: "Simplifiez la gestion de vos clients en regroupant toutes leurs informations au même endroit. Ajoutez de nouveaux contacts, suivez vos interactions et retrouvez rapidement chaque détail pour optimiser votre temps et améliorer votre relation client.",
            imagePath: header1,
            tasks: [
                "Ajouter et gérer vos clients",
                "Suivre les interactions et échanges",
                "Retrouver les informations rapidement"
            ]
        },
        {
            title: "Créez vos devis et factures",
            subtitle: "Créez, modifiez ou supprimez vos devis et factures en quelques clics. Filtrez-les facilement par statut et téléchargez-les instantanément en PDF.",
            imagePath: header10,
            tasks: [
                "Créer et modifier des devis",
                "Générer des factures PDF",
                "Filtrer par statut"
            ]
        },
        {
            title: "Automatisez vos relances clients",
            subtitle: "Envoyez vos relances en un seul clic grâce à des messages personnalisés et automatiques. Gagnez du temps et assurez un suivi professionnel de vos paiements.",
            imagePath: header9,
            tasks: [
                "Envoyer des relances automatiques",
                "Personnaliser les messages",
                "Suivi des paiements en un clic"
            ]
        },
        {
            title: "Partage facile avec votre comptable",
            subtitle: "Invitez votre comptable en toute simplicité, exportez vos données en CSV et envoyez-les automatiquement par e-mail. Facilitez vos échanges et gagnez un temps précieux.",
            imagePath: header5,
            tasks: [
                "Inviter votre comptable",
                "Exporter les données en CSV",
                "Envoyer automatiquement par e-mail"
            ]
        },
    ];


    return (
        <section
            id="services"
            className="min-h-screen bg-white flex flex-col items-center lg:justify-start justify-center lg:pt-5 pt-2 lg:pb-10 pb-2">
            {tabContentList.map((tab, index) => (
                <HeaderSection
                    key={index}
                    {...tab}
                    imagePosition={index % 2 === 0 ? "left" : "right"}
                />
            ))}
        </section>
    );
};

export default TabMenu;
